export const getColorShades = (color: string) => {
    const basePercent = hexToPercent(color);
    const shadesPercentage: any = {
        50: basePercent + 20,
        100: basePercent + 15,
        200: basePercent + 10,
        300: basePercent + 5,
        400: basePercent,
        500: basePercent - 5,
        600: basePercent - 10,
        700: basePercent - 15,
        800: basePercent - 20,
    };
    let primaryColorObj: any = {};
    Object.keys(shadesPercentage).map((key: any) => {
        primaryColorObj[key] = colorShades(color, shadesPercentage[key]);
    });
    return primaryColorObj;
};
export const colorShades = (color: any, amount: any) => {
    return (
        '#' +
        color
            .replace(/^#/, '')
            .replace(/../g, (color: any) =>
                (
                    '0' +
                    Math.min(
                        255,
                        Math.max(0, parseInt(color, 16) + amount)
                    ).toString(16)
                ).substr(-2)
            )
    );
};
export const hexToPercent = (color: string) => {
    const r = +(color.substring(1, 2), 16);
    const g = +(color.substring(3, 2), 16);
    const b = +(color.substring(4, 2), 16);
    return (r * 299 + g * 587 + b * 114) / 1000;
};
